<template>
  <div id="doctor-reports" class="wrrapper">
    <page-heading title="Doctor's Report">
      <template #content>
        <div class="flex align-center no-print">
          <Select
            v-if="isSuperAdmin"
            class="reffered-to mr-1"
            placeholder="Filter by"
            :input="handleUser"
            :options="doctors"
          />
          <DateRangePicker @update="updateDate" />
          <Select
            v-if="isAdmin"
            class="mr-2"
            styles="expenses-select"
            :placeholder="
              brachData.length
                ? brachData && brachData.find(item => item.key == 1).name
                : ''
            "
            :input="handleBranchChange"
            :options="brachData"
          />
          <ExportButtons @pdf="handleExportPdf" @excel="handleExportExcel" />
        </div>
      </template>
    </page-heading>
    <div class="content" id="doctors--report">
      <data-table
        :loading="loading"
        :cols="report"
        :rows="financeReport"
        height="calc(100vh - 15rem)"
        total
      >
      </data-table>
    </div>
  </div>
</template>

<script>
import DataTable from "@/components/DataTable";
import {
  formatedDate,
  titleCase,
  getBranchLogo
} from "@/utils/helpers";
import DateRangePicker from "@/components/DateRangePIcker";
import Select from "@/components/Select";
import ExportButtons from "@/components/ExportButtons.vue";
import { exportReportPdf, exportReportExcel } from "@/utils/reportExport";
import { mapActions, mapGetters } from "vuex";
export default {
  components: {
    DateRangePicker,
    DataTable,
    Select,
    ExportButtons
  },
  data() {
    return {
      filters: {
        end_date: formatedDate(),
        start_date: formatedDate(),
        isOther: this.isOther,
        branchId: null
      },
      doctor: "",
      brachData: [],
      isAdmin: null,
      bussinessLogoUrl: "",
      branchLogoUrl: ""
    };
  },
  methods: {
    ...mapActions({
      filterDoctorReports: "reports/filterDoctorReports",
      listDoctors: "receptionist/listDoctors"
    }),
    ...mapActions("expenses", ["fetchBranch"]),
    handleUser(val) {
      if (val && val !== null) {
        this.doctor = val.name;
        this.filters.doctor_id = val.id;
        this.filterDoctorReports(this.filters);
      } else {
        this.doctor = "";
        delete this.filters.doctor_id;
        this.filterDoctorReports(this.filters);
      }
    },
    updateDate(val) {
      this.filters.end_date = formatedDate(val.endDate);
      this.filters.start_date = formatedDate(val.startDate);
      this.filterDoctorReports(this.filters);
    },
    exportInput() {
      return {
        title: this?.doctor
          ? `Dr. ${titleCase(this?.doctor)} Report`
          : "Doctor's Report",
        dateRange: {
          start: this.filters.start_date,
          end: this.filters.end_date
        },
        printedBy: this.userInfo.full_name,
        businessLogoUrl: this.bussinessLogoUrl,
        branchLogoUrl: this.branchLogoUrl,
        cols: this.report,
        rows: this.financeReport,
        fileName: "doctors-report"
      };
    },
    handleExportPdf() {
      exportReportPdf(this.exportInput());
    },
    handleExportExcel() {
      exportReportExcel(this.exportInput());
    },
    handleBranchChange(val) {
      if (val && val !== null) {
        this.filters.branchId = val.key;

        const object = getBranchLogo(this.fetchUserBranch, val.key);
        this.branchLogoUrl = object;
        this.filterDoctorReports(this.filters);
      }
      if (val === null) {
        this.filters.branchId = 1;
        this.filterDoctorReports(this.filters);
      }
    }
  },
  computed: {
    ...mapGetters({
      loading: "loading",
      financeReport: "reports/financeReport",
      doctorsList: "receptionist/doctorsList",
      role: "auth/role",
      isOther: "auth/isOther",
      userInfo: "auth/userInfo",
      fetchUserBranch: "expenses/fetchUserBranch",
      settings: "bussiness/settings"
    }),
    isSuperAdmin() {
      return this.role && this.role.length > 1;
    },
    roleId() {
      const { id } = this.role && this.role.find(item => item);
      return id;
    },
    report() {
      const filterArr = [];
      const arr = this.financeReport || [];
      const [newArr] = [...arr];
      const disable = ["full_name", "date", "id"];
      if (newArr) {
        Object.keys(newArr).map(item => {
          filterArr.push({
            column: item,
            label: item.split("_").join(" "),
            sortable: true,
            sum: disable.includes(item) ? false : true,
            link: item === "full_name",
            routerName: item === "full_name" ? "doctorReportDetails" : ""
          });
        });
        filterArr.unshift({ column: "serial", label: "#", width: "60" });
      }
      return filterArr;
    },
    doctors() {
      return (
        this.doctorsList &&
        this.doctorsList.map(item => ({
          name: item.full_name,
          id: item.id
        }))
      );
    }
  },
  async mounted() {
    this.isAdmin = this.userInfo?.userRole.some(({ name }) => name === "admin");

    await this.fetchBranch();

    await this.fetchUserBranch?.map(elem => {
      this.brachData.push({ name: elem.name, key: elem.id });
    });

    this.bussinessLogoUrl = this.userInfo?.bussinessLogoUrl;

    this.branchLogoUrl = getBranchLogo(
      this.fetchUserBranch,
      this.userInfo.userBranchId
    );

    // if (this.isSuperAdmin) {
    this.filters.branchId = this.userInfo.userBranchId;
    await this.filterDoctorReports(this.filters);
    // } else {
    //   // this.filters.doctor_id = this.userInfo.id;
    //   this.filters.branchId = this.userInfo.userBranchId;
    //   await this.filterDoctorReports(this.filters);
    // }
    await this.listDoctors();
  }
};
</script>

<style>
@import "../../../assets/css/print.css";
</style>
